export enum ResultsOverallType {
  PRONUNCIATION = 'pronunciation',
  STRUCTURE = 'structure',
  VOCABULARY = 'vocabulary',
  FLUENCY = 'fluency',
  COMPREHENSION = 'comprehension',
  INTERACTIONS = 'interactions',
}
